div.progress {
  flex: 0 0 16.5rem;
  margin-left: 3.5rem;

  nav.progress {
    display: flex;
    flex-direction: column;
    gap: 2.5rem;

    div:global(.column) {
      display: flex;
      flex-direction: column;
      gap: 1rem;
    }
  }
}

span:global(.item),
a:global(.item) {
  text-decoration: none;
  color: inherit;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
}
